import { z } from 'zod';

// Reserved names that cannot be used for dashboards
const RESERVED_NAMES = ['new'];

export const createNameSchema = (nameType = 'Name', length = 25, existingNames: string[] = []) =>
  z
    .string()
    .trim()
    .min(1, `${nameType} is required`)
    .max(length, `${nameType} must be ${length} characters or less`)
    .refine(s => !/[?#%;]/u.test(s), `${nameType} has invalid characters`)
    .refine(s => s !== '.' && s !== '..', `${nameType} is not valid`)
    // eslint-disable-next-line no-control-regex
    .refine(s => !/[\u0000-\u001F\u007F]/.test(s), `${nameType} has invalid characters`)
    .refine(
      s => !RESERVED_NAMES.includes(s.toLowerCase()),
      `${nameType} cannot be "${RESERVED_NAMES.join('", "')}" (reserved name)`
    )
    .refine(
      s => !existingNames.includes(s.toLowerCase()),
      `${nameType} already exists. Please choose a different name.`
    )
    .transform(s => s.normalize('NFC'));
